import { render, staticRenderFns } from "./AdditionalServices.vue?vue&type=template&id=31b9aace&scoped=true&"
import script from "./AdditionalServices.vue?vue&type=script&lang=js&"
export * from "./AdditionalServices.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalServices.vue?vue&type=style&index=0&id=31b9aace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b9aace",
  null
  
)

export default component.exports